import { useState } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { LangGraphService } from '@/lib/langgraph'
import './App.css'

function App() {
  const [message, setMessage] = useState('Hello World!')
  const [isLoading, setIsLoading] = useState(false)

  const handleLangGraphTest = async () => {
    setIsLoading(true)
    try {
      const result = await LangGraphService.testConnection()
      setMessage(result.message)
    } catch (error) {
      setMessage('Error connecting to LangGraph service')
      console.error('LangGraph error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <Card className="shadow-lg">
            <CardHeader className="text-center">
              <CardTitle className="text-3xl font-bold text-primary">
                PWA Cloudflare Workers Template
              </CardTitle>
              <CardDescription className="text-lg">
                A modern PWA built with React, Vite, TailwindCSS, Shadcn UI, and Cloudflare Workers
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="text-center">
                <h2 className="text-2xl font-semibold mb-4">{message}</h2>
                <div className="flex gap-4 justify-center">
                  <Button 
                    onClick={handleLangGraphTest}
                    disabled={isLoading}
                    variant="default"
                  >
                    {isLoading ? 'Testing...' : 'Test LangGraph'}
                  </Button>
                  <Button 
                    onClick={() => setMessage('Hello World!')}
                    variant="outline"
                  >
                    Reset
                  </Button>
                </div>
              </div>
              
              <div className="border-t pt-6">
                <h3 className="text-lg font-semibold mb-3">Features:</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>✅ Progressive Web App (PWA) support</li>
                  <li>✅ React 18 with TypeScript</li>
                  <li>✅ Vite for fast development and building</li>
                  <li>✅ TailwindCSS for styling</li>
                  <li>✅ Shadcn UI components</li>
                  <li>✅ Cloudflare Workers deployment ready</li>
                  <li>✅ LangGraph integration stub</li>
                  <li>✅ Service Worker for offline support</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default App
